module.exports = "<mat-toolbar role=\"footer\" class=\"mat-elevation-z3 music-control\">\n  <app-player></app-player>\n</mat-toolbar>"